/** @format */

import React, { FunctionComponent, ReactElement, useState } from 'react';
import {
    SimCardServiceItemConfiguration,
    SimCardServiceTypeConfigurationGet,
    SimCardServiceTypeConfigurationPost,
    SimCardServiceTypeConfigurationPut,
    SimCardServiceTypeItem,
} from '../../../../../interfaces/collections/SimCardServiceInterface';
import Card from '../../../../../components/Card/Card';
import CardBody from '../../../../../components/Card/CardBody';
import CardHeader from '../../../../../components/Heading/CardHeaderExt';
import { Build } from '@material-ui/icons';
import GridContainer from '../../../../../components/Grid/GridContainer';
import GridItem from '../../../../../components/Grid/GridItem';
import Typography from '@material-ui/core/Typography';
import I18n from '../../../../../components/Translate/I18n';
import { roles, UserRoleHelper } from '../../../../../helpers/UserRoleHelper';
import CustomTextButtom from '../../../../../components/Buttons/CustomTextButton';
import { OplSimCardServiceTypeSmsMsgEdit } from './OplSimCardServiceTypeSmsMsgEdit';
import { ServicesMvneType } from '../../../../../modules/lib/hooks/useOperatorType';

type OplSimCardServiceTypeSmsMsgType = {
    simCardServiceType: SimCardServiceTypeItem;
    languageName: string;
    simCardServiceTypeConfiguration: SimCardServiceTypeConfigurationGet | SimCardServiceTypeConfigurationPost | SimCardServiceTypeConfigurationPut;
    isPost: boolean;
    languageId?: number | null;
    id?: string | null;
    reloadConfiguration: () => void;
    platformResellerId: number;
};

export const OplSimCardServiceTypeSmsMsg: FunctionComponent<OplSimCardServiceTypeSmsMsgType> = ({
    simCardServiceTypeConfiguration,
    simCardServiceType,
    languageName,
    isPost,
    languageId,
    id,
    reloadConfiguration,
    platformResellerId,
}): ReactElement => {
    const [configuration, setConfiguration] = useState<SimCardServiceItemConfiguration>(JSON.parse(simCardServiceTypeConfiguration.configuration));
    const [edit, setEdit] = useState(false);
    const editComponent = (): void => setEdit(true);

    return (
        <Card>
            <CardHeader
                icon={<Build />}
                trans="prov:feature.sms_message_configure_with_language"
                transValueObject={{ language: languageName.toUpperCase() }}
            />
            <CardBody>
                <GridContainer>
                    <GridItem xs={6}>
                        <Typography variant="subtitle2" gutterBottom>
                            <I18n trans="prov:feature.package_activation" />
                        </Typography>
                    </GridItem>
                    <GridItem xs={6}>
                        <I18n trans={!configuration.PACKAGE_ACTIVATE ? 'general:common.no' : 'general:common.yes'} />
                        <br />
                        <Typography variant="subtitle2">{configuration.PACKAGE_ACTIVATE_MSG}</Typography>
                    </GridItem>
                    {simCardServiceType.serviceType === ServicesMvneType.BME && (
                        <>
                            <GridItem xs={6}>
                                <Typography variant="subtitle2" gutterBottom>
                                    <I18n trans="prov:feature.usage_80_percent" />
                                </Typography>
                            </GridItem>
                            <GridItem xs={6}>
                                <I18n trans={!configuration.PACKAGE_USAGE_80_PERCENT ? 'general:common.no' : 'general:common.yes'} />
                                <br />
                                <Typography variant="subtitle2">{configuration.PACKAGE_USAGE_80_PERCENT_MSG}</Typography>
                            </GridItem>
                            <GridItem xs={6}>
                                <Typography variant="subtitle2" gutterBottom>
                                    <I18n trans="prov:feature.usage_all_percent" />
                                </Typography>
                            </GridItem>
                            <GridItem xs={6}>
                                <I18n trans={!configuration.PACKAGE_USAGE_ALL ? 'general:common.no' : 'general:common.yes'} />
                                <br />
                                <Typography variant="subtitle2">{configuration.PACKAGE_USAGE_ALL_MSG}</Typography>
                            </GridItem>
                            <GridItem xs={6}>
                                <Typography variant="subtitle2" gutterBottom>
                                    <I18n trans="prov:feature.package_near_expire" />
                                </Typography>
                            </GridItem>
                            <GridItem xs={6}>
                                <I18n trans={!configuration.PACKAGE_NEAR_EXPIRE ? 'general:common.no' : 'general:common.yes'} />
                                <br />
                                <Typography variant="subtitle2">{configuration.PACKAGE_NEAR_EXPIRE_MSG}</Typography>
                            </GridItem>
                        </>
                    )}
                    <GridItem xs={6}>
                        <Typography variant="subtitle2" gutterBottom>
                            <I18n trans="prov:feature.package_expire" />
                        </Typography>
                    </GridItem>
                    <GridItem xs={6}>
                        <I18n trans={!configuration.PACKAGE_EXPIRE ? 'general:common.no' : 'general:common.yes'} />
                        <br />
                        <Typography variant="subtitle2">{configuration.PACKAGE_EXPIRE_MSG}</Typography>
                    </GridItem>
                    {UserRoleHelper.checkRole(roles.ROLE_SIM_CARD_SERVICE_TYPE_PUT) && (
                        <GridItem xs={12} style={{ textAlign: 'right' }}>
                            <CustomTextButtom callback={editComponent} label="general:common.edit" size="sm" />
                        </GridItem>
                    )}
                </GridContainer>
                <OplSimCardServiceTypeSmsMsgEdit
                    open={edit}
                    reload={reloadConfiguration}
                    simCardServiceType={simCardServiceType}
                    close={(): void => setEdit(false)}
                    simCardServiceTypeConfiguration={simCardServiceTypeConfiguration}
                    languageName={languageName}
                    isPost={isPost}
                    id={id}
                    languageId={languageId}
                    platformResellerId={platformResellerId}
                />
            </CardBody>
        </Card>
    );
};
